/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const NEGATIVE_SIGN = '-';
export const DECIMAL_DOT = '.';
